import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledPlaceholderText = styled(Text)`
   color: ${(props) => props.theme.placeholder};
`;

StyledPlaceholderText.displayName = 'StyledPlaceholderText';
